import { render, staticRenderFns } from "./CompanionOptionsButton.vue?vue&type=template&id=1612058a&scoped=true&"
import script from "./CompanionOptionsButton.vue?vue&type=script&lang=js&"
export * from "./CompanionOptionsButton.vue?vue&type=script&lang=js&"
import style0 from "./CompanionOptionsButton.vue?vue&type=style&index=0&id=1612058a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1612058a",
  null
  
)

export default component.exports